export class CalculationParams {
  workingDays: number
  leisureTime: number
  carType: CarType
  engineType: EngineType

  constructor(workingDays: number, leisureTime: number, carType: CarType, engineType: EngineType) {
    this.workingDays = workingDays
    this.leisureTime = leisureTime
    this.carType = carType
    this.engineType = engineType
  }
}

export enum CarType {
  small,
  medium,
  suv
}

export enum EngineType {
  benzin,
  diesel,
  hybrid,
  electric
}
